import {Component, signal,} from '@angular/core';
import moment from 'moment';
import {DateFilter, TimeRangeFilter} from '../../../../shared/models/DateFilter';
import {ActivatedRoute, Router} from '@angular/router';
import {CloseableAndFilterableInsight} from '../../closeable-filterable-insight.class';
import {MatIconButton} from '@angular/material/button';
import {MatTooltip} from '@angular/material/tooltip';
import {MatIcon} from '@angular/material/icon';
import {FilterBarComponent} from '../../../../shared/components/filter-bar/filter-bar.component';
import {NgClass} from '@angular/common';
import {FilterButtonComponent} from '../../../../shared/components/buttons/filter-button/filter-button.component';
import {AnalyticsReportViewComponent} from '../analytics-report-view/analytics-report-view.component';

@Component({
  imports: [
    MatIconButton,
    MatTooltip,
    MatIcon,
    MatIconButton,
    MatTooltip,
    FilterBarComponent,
    NgClass,
    FilterButtonComponent,
    AnalyticsReportViewComponent,
  ],
  selector: 'app-analytics-report',
  templateUrl: './analytics-report.component.html'
})
export class AnalyticsReportComponent extends CloseableAndFilterableInsight {
  protected readonly TimeRangeFilter = TimeRangeFilter;

  isLoading = false;
  dateFilter = signal<DateFilter>(null);

  constructor(protected router: Router,
              protected activatedRoute: ActivatedRoute) {
    super(router, activatedRoute);
    // always display filter for dates
    this.showingFilterBar = true;
  }

  dateFilterChanged(dateFilter: DateFilter) {
    this.dateFilter.set(dateFilter);
  }

}
